function setOutOfStock(
	// val: string | undefined,
	swatch: HTMLElement,
	// product: string
) {
	swatch.classList.remove("hide");
	swatch.classList.add("out-of-stock");
	// if (String(val) === product) {
	// }
}

export default setOutOfStock;
